import requester, { createRequestHeaders } from '@zg-rentals/particles-js-requester';
import urlUtils from '../util/urlUtils';

const urlConstants = urlUtils.getNotficationEndpoints();

function makeClient({
  proxyPath,
  method,
  csrf_token,
  api,
}: {
  proxyPath: string;
  method: 'get' | 'post' | 'put' | 'delete';
  csrf_token: string;
  api: string;
}) {
  return requester({
    proxyPath,
    api,
    headers: {
      ...createRequestHeaders({
        method: method,
      }),
      ...{
        rental_csrftoken: csrf_token,
      },
    },
  });
}

const notificationCenterApi = {
  getAllNotifications: async (
    proxyPath: string,
    csrf_token: string,
    start: number,
    limit: number = 10,
    includeFlagForNewNotifications = false,
    api: string,
  ) => {
    const client = makeClient({ proxyPath, csrf_token, method: 'get', api });

    try {
      const response = await client.get(urlConstants.getAllNotificationsEndpoint, {
        params: {
          start,
          limit,
          includeHasNewNotificationsForNotificationCenter: includeFlagForNewNotifications,
        },
      });

      return response.data;
    } catch (err) {
      return err;
    }
  },
  removeNotification: async (proxyPath: string, csrf_token: string, notificationId: string, api: string) => {
    const client = makeClient({ proxyPath, csrf_token, method: 'post', api });

    try {
      const response = await client.post(
        urlConstants.deleteNotificationEndpoint,
        {},
        {
          params: {
            notificationId,
          },
        },
      );

      if (response.data.success) {
        return true;
      } else {
        throw new Error('error in deleting notification');
      }
    } catch (err) {
      return err;
    }
  },
  markAsRead: async (proxyPath: string, csrf_token: string, notificationId: string, api: string) => {
    const client = makeClient({ proxyPath, csrf_token, method: 'post', api });

    try {
      const response = await client.post(
        urlConstants.markAsReadEndpoint,
        {},
        {
          params: {
            notificationId,
          },
        },
      );

      if (response.data.success) {
        return true;
      } else {
        throw new Error('error in marking as read');
      }
    } catch (err) {
      return err;
    }
  },
  markAllAsRead: async (proxyPath: string, csrf_token: string, notificationStatus: string = 'read', api: string) => {
    const client = makeClient({ proxyPath, csrf_token, method: 'post', api });

    try {
      const response = await client.post(
        urlConstants.markAllAsReadEndpoint,
        {},
        {
          params: {
            notificationStatus,
          },
        },
      );

      if (response.data.success) {
        return true;
      } else {
        throw new Error('error in marking all as read');
      }
    } catch (err) {
      return err;
    }
  },
  updateNotificationreadTimestamp: async (proxyPath: string, csrf_token: string, api: string) => {
    const client = makeClient({ proxyPath, csrf_token, method: 'post', api });

    try {
      const response = await client.post(urlConstants.updateReadTimestampEndpoint);

      if (response.data.success) {
        return true;
      } else {
        throw new Error('error updating read timestamp');
      }
    } catch (err) {
      return err;
    }
  },
};

export default notificationCenterApi;
